import { dollarsToCents } from '../../helpers/util';
import { addValidationRule, validationRules } from 'formsy-react';

addValidationRule('isMoney', (values, value) => {
  return dollarsToCents(value) > 0;
});

addValidationRule('isEmailList', (values, value) => {
  const emails = value.split(',').map(item => item.trim());
  return emails.every(email => validationRules.isEmail({}, email));
});

// required only if another value is a certain value
addValidationRule('requiredIf', (values, value, required) => {
  const isRequired = Object.entries(required).every(
    ([key, val]) => values[key] === val
  );
  // is not required or is required and not empty
  return (
    !isRequired || (isRequired && !validationRules.isEmptyString({}, value))
  );
});

addValidationRule('isLessThan', (values, value, compare) => {
  return value < compare;
});

addValidationRule('isGreaterThan', (values, value, compare) => {
  return value > compare;
});



// WEBPACK FOOTER //
// ./src/components/form/validators.js